"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshPinComponentOrders = exports.nextNPinComponentOrders = exports.changePinComponentsOrder = void 0;
const pins_shared_1 = require("@lessonup/pins-shared");
const fractional_indexing_jittered_1 = require("fractional-indexing-jittered");
function changePinComponentsOrder(pinComponents, componentIds, action) {
    const sorted = (0, pins_shared_1.sortPinComponents)(pinComponents);
    const orders = sorted.map((component) => component.order);
    const componentsToMove = sorted.filter((component) => componentIds.includes(component.id));
    if (componentsToMove.length !== componentIds.length) {
        throw new Error(`Not all components with ids ${componentIds.join(', ')} were found in list`);
    }
    const generator = new fractional_indexing_jittered_1.IndexGenerator(orders);
    const n = componentIds.length;
    let newOrders = [];
    if (action === 'toFront') {
        newOrders = generator.nKeysEnd(n);
    }
    else if (action === 'toBack') {
        newOrders = generator.nKeysStart(n);
    }
    else if (action === 'forward') {
        // TODO: ED-271: What do we want to do if there are multiple components selected?
        const firstAfter = firstComponentAfter(sorted, componentsToMove);
        if (!firstAfter)
            return;
        newOrders = generator.nKeysAfter(firstAfter.order, n);
    }
    else if (action === 'backward') {
        const before = firstComponentBefore(sorted, componentsToMove);
        if (!before)
            return;
        newOrders = generator.nKeysBefore(before.order, n);
    }
    if (newOrders.length === n) {
        componentsToMove.forEach((component, i) => {
            component.order = newOrders[i];
        });
    }
}
exports.changePinComponentsOrder = changePinComponentsOrder;
/**
 * Find the max order of the pin components, these do not have to be sorted, and generate n jittered keys after that.
 */
function nextNPinComponentOrders(pin, n) {
    const maxOrder = pin.pinComponents.reduce((max, component) => (component.order > max ? component.order : max), '');
    return (0, fractional_indexing_jittered_1.generateNJitteredKeysBetween)(maxOrder || null, null, n);
}
exports.nextNPinComponentOrders = nextNPinComponentOrders;
/**
 * When a pin is created or copied, we can use this function to refresh the order of the pin components,
 * to reduce the length of the order keys.
 */
function refreshPinComponentOrders(pin) {
    // We do not need jittered keys here, because this action can never be interleaved with other actions.
    const newOrders = (0, fractional_indexing_jittered_1.generateNKeysBetween)(null, null, pin.pinComponents.length);
    const sorted = (0, pins_shared_1.sortPinComponents)(pin.pinComponents);
    sorted.forEach((component, i) => {
        component.order = newOrders[i];
    });
    pin.pinComponents = sorted;
    return pin;
}
exports.refreshPinComponentOrders = refreshPinComponentOrders;
// first component after the given components, with exclusion of the given components
function firstComponentAfter(sorted, components) {
    const first = components[0];
    const indexOfFirst = sorted.findIndex((component) => first.id === component.id);
    return sorted.find((component, i) => i > indexOfFirst && !components.includes(component));
}
// first component before the given components, assuming the given components are sorted
function firstComponentBefore(sorted, components) {
    const first = components[0];
    const indexOfFirst = sorted.findIndex((component) => first.id === component.id);
    return sorted[indexOfFirst - 1];
}
//# sourceMappingURL=order.js.map